import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { useResolveLink } from '../../hooks/useResolveLink';
import { AppLinkProps } from './AppLink.types';

export const AppLink = forwardRef<HTMLAnchorElement, AppLinkProps>((props, ref) => {
  const { children, className, onClick } = props;

  const { isInternal, linkProps: autoResolved } = useResolveLink(
    'url' in props ? props.url : undefined,
    'blank' in props ? props.blank : undefined,
  );

  if ('to' in props && props.to) {
    return (
      <Link to={props.to} className={className} onClick={onClick} ref={ref as React.Ref<HTMLAnchorElement>}>
        {children}
      </Link>
    );
  }

  if ('href' in props && props.href) {
    return (
      <a href={props.href} target={props.target} rel={props.rel} className={className} onClick={onClick} ref={ref}>
        {children}
      </a>
    );
  }

  if ('url' in props && props.url) {
    if (isInternal) {
      return (
        <Link to={autoResolved.to} className={className} onClick={onClick} ref={ref as React.Ref<HTMLAnchorElement>}>
          {children}
        </Link>
      );
    }

    const external = autoResolved as { href: string; target?: string; rel?: string };
    return (
      <a
        href={external.href}
        target={external.target}
        rel={external.rel}
        className={className}
        onClick={onClick}
        ref={ref}
      >
        {children}
      </a>
    );
  }

  if (onClick) {
    return (
      <button
        type="button"
        className={className}
        onClick={onClick}
        ref={ref as unknown as React.Ref<HTMLButtonElement>}
      >
        {children}
      </button>
    );
  }

  return (
    <span className={className} ref={ref as React.Ref<HTMLSpanElement>}>
      {children}
    </span>
  );
});

AppLink.displayName = 'AppLink';
